import React from 'react';
// import React, { useState, useEffect } from 'react';
// import { 
//   FaUsers, FaMoneyBillWave, FaMoneyBillAlt, 
//   FaCalendarAlt, FaChartLine 
// } from 'react-icons/fa';
// import { sociosAPI, receitasAPI, despesasAPI, eventosAPI, mensalidadesAPI } from '../../services/api';
import './Dashboard.css';

const Dashboard = () => {
  // const [stats, setStats] = useState({
  //   totalSocios: 0,
  //   sociosAtivos: 0,
  //   totalReceitas: 0,
  //   totalDespesas: 0,
  //   saldo: 0,
  //   proximosEventos: 0,
  //   inadimplentes: 0,
  // });
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   loadDashboardData();
  // }, []);

  // const loadDashboardData = async () => {
  //   try {
  //     setLoading(true);

  //     // Get current month dates
  //     const now = new Date();
  //     const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  //     const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      
  //     const startDate = firstDay.toISOString().split('T')[0];
  //     const endDate = lastDay.toISOString().split('T')[0];

  //     // Load all data in parallel
  //     const [
  //       sociosRes,
  //       receitasRes,
  //       despesasRes,
  //       eventosRes,
  //       inadimplentesRes,
  //     ] = await Promise.all([
  //       sociosAPI.getAll(),
  //       receitasAPI.getTotal({ startDate, endDate }),
  //       despesasAPI.getTotal({ startDate, endDate }),
  //       eventosAPI.getAll({ startDate, endDate }),
  //       mensalidadesAPI.getInadimplentes(),
  //     ]);

  //     const socios = sociosRes.data.data;
  //     const totalReceitas = receitasRes.data.data.total || 0;
  //     const totalDespesas = despesasRes.data.data.total || 0;
  //     const eventos = eventosRes.data.data;
  //     const inadimplentes = inadimplentesRes.data.data;

  //     setStats({
  //       totalSocios: socios.length,
  //       sociosAtivos: socios.filter(s => s.status === 'ativo').length,
  //       totalReceitas: parseFloat(totalReceitas),
  //       totalDespesas: parseFloat(totalDespesas),
  //       saldo: parseFloat(totalReceitas) - parseFloat(totalDespesas),
  //       proximosEventos: eventos.length,
  //       inadimplentes: inadimplentes.length,
  //     });
  //   } catch (error) {
  //     console.error('Error loading dashboard:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const formatCurrency = (value) => {
  //   return new Intl.NumberFormat('pt-BR', {
  //     style: 'currency',
  //     currency: 'BRL',
  //   }).format(value);
  // };

  // if (loading) {
  //   return (
  //     <div className="dashboard">
  //       <div className="dashboard-header">
  //         <h1>Dashboard</h1>
  //       </div>
  //       <div className="loading">Carregando...</div>
  //     </div>
  //   );
  // }

  return (
    <div></div>
    // <div className="dashboard">
    //   <div className="dashboard-header">
    //     <h1>Dashboard</h1>
    //     <p>Visão geral do sistema</p>
    //   </div>

    //   <div className="stats-grid">
    //     <div className="stat-card">
    //       <div className="stat-icon socios">
    //         <FaUsers />
    //       </div>
    //       <div className="stat-content">
    //         <h3>Sócios</h3>
    //         <p className="stat-value">{stats.sociosAtivos}</p>
    //         <span className="stat-label">de {stats.totalSocios} cadastrados</span>
    //       </div>
    //     </div>

    //     <div className="stat-card">
    //       <div className="stat-icon receitas">
    //         <FaMoneyBillWave />
    //       </div>
    //       <div className="stat-content">
    //         <h3>Receitas (mês)</h3>
    //         <p className="stat-value">{formatCurrency(stats.totalReceitas)}</p>
    //         <span className="stat-label">total arrecadado</span>
    //       </div>
    //     </div>

    //     <div className="stat-card">
    //       <div className="stat-icon despesas">
    //         <FaMoneyBillAlt />
    //       </div>
    //       <div className="stat-content">
    //         <h3>Despesas (mês)</h3>
    //         <p className="stat-value">{formatCurrency(stats.totalDespesas)}</p>
    //         <span className="stat-label">total gasto</span>
    //       </div>
    //     </div>

    //     <div className="stat-card">
    //       <div className={`stat-icon ${stats.saldo >= 0 ? 'saldo-positivo' : 'saldo-negativo'}`}>
    //         <FaChartLine />
    //       </div>
    //       <div className="stat-content">
    //         <h3>Saldo (mês)</h3>
    //         <p className={`stat-value ${stats.saldo >= 0 ? 'positive' : 'negative'}`}>
    //           {formatCurrency(stats.saldo)}
    //         </p>
    //         <span className="stat-label">receitas - despesas</span>
    //       </div>
    //     </div>

    //     <div className="stat-card">
    //       <div className="stat-icon eventos">
    //         <FaCalendarAlt />
    //       </div>
    //       <div className="stat-content">
    //         <h3>Eventos (mês)</h3>
    //         <p className="stat-value">{stats.proximosEventos}</p>
    //         <span className="stat-label">agendados</span>
    //       </div>
    //     </div>

    //     <div className="stat-card">
    //       <div className="stat-icon inadimplentes">
    //         <FaUsers />
    //       </div>
    //       <div className="stat-content">
    //         <h3>Inadimplentes</h3>
    //         <p className="stat-value">{stats.inadimplentes}</p>
    //         <span className="stat-label">sócios com pendências</span>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default Dashboard;
